'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
require('../../../../../aviary-core/dist/cjs/index.cjs');
var InternalSkeleton_web = require('../../internal/InternalSkeleton/InternalSkeleton.web.cjs');
var Avatar_web_styles = require('../Avatar/Avatar.web.styles.cjs');
var Button_web_styles = require('../Button/Button.web.styles.cjs');
var Skeleton_web_styles = require('./Skeleton.web.styles.cjs');
var index = require('../../../../../../_virtual/index.cjs');

/**
 * A skeleton component that can be used to show a loading state
 *
 * {@link https://aviary.supernova-docs.io/latest/components/skeleton/overview-2VHKPZVJ | Documentation}
 *
 * {@link https://git.fullscript.io/developers/aviary/-/blob/development/packages/aviary-web/src/components/atoms/Skeleton/Skeleton.web.tsx | View in GitLab}
 *
 * @scope Core
 */ const Skeleton = (props)=>{
    const { isCircular, type, width: customWidth, height: customHeight, isFullWidth, ...rest } = props;
    const theme = react.useTheme();
    let defaultWidth;
    let defaultHeight;
    switch(type){
        case "typography":
            {
                const typographyType = props.typographyType || "body";
                const typographySizeMapper = {};
                Object.keys(theme.aviaryTypography).forEach((key)=>{
                    typographySizeMapper[key] = {
                        width: "30%",
                        height: parseInt(theme.aviaryTypography[key].lineHeight)
                    };
                });
                const typographySize = typographySizeMapper[typographyType];
                defaultWidth = typographySize.width;
                defaultHeight = typographySize.height;
                break;
            }
        case "button":
            {
                const buttonSize = Button_web_styles.buttonSkeletonSizes[props.size || "medium"];
                defaultWidth = buttonSize.width;
                defaultHeight = buttonSize.height;
                break;
            }
        case "avatar":
            {
                const avatarSize = Avatar_web_styles.avatarSkeletonSizes[props.size || "medium"];
                defaultWidth = avatarSize.width;
                defaultHeight = avatarSize.height;
                break;
            }
    }
    const width = customWidth ?? defaultWidth;
    const height = customHeight ?? defaultHeight;
    return /*#__PURE__*/ jsxRuntime.jsx(InternalSkeleton_web.InternalSkeleton, {
        width: width,
        height: height,
        borderRadius: index.__exports.getBorderRadius(isCircular, type),
        customStyles: type === "typography" ? Skeleton_web_styles.typographySkeleton : undefined,
        isFullWidth: isFullWidth,
        ...rest
    });
};

exports.Skeleton = Skeleton;
//# sourceMappingURL=Skeleton.web.cjs.map
